import { Subscription } from 'rxjs';
import { LanguageService } from './../../../Services/languageService';
import { userService } from './../../../Services/userService';
import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { AddNewPolicyMdl } from '../../../Models/AddNewPolicy';
import { AddNewPolicyReqMdl } from '../../../Models/AddNewPolicyReqMdl';
import { restURL } from '../../../Models/restURL';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MotorStatusMdl } from '../../../Models/MotorStatusMdl';
import Swal from 'sweetalert2';
import { motorProposalService } from '../../../Services/motorProposalService';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import { TranslateService } from '@ngx-translate/core';


declare let $: any;
@Component({
  selector: 'NewProposal',
  templateUrl: './NewProposal.html',
  styleUrls: ['./NewProposal.css']
})
export class NewProposal {
  public AddNewPolicyObj: AddNewPolicyMdl = new AddNewPolicyMdl();
  public newPolicyReq: AddNewPolicyReqMdl = new AddNewPolicyReqMdl();
  public newPolicyRes: AddNewPolicyReqMdl = new AddNewPolicyReqMdl();
  public isShowLoading: boolean = false;
  public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public apiUrl: restURL = new restURL()
  public st: MotorStatusMdl = new MotorStatusMdl();
  public disableTOS: boolean;
  public isError: boolean = false;
  public Lng: string = "en";
  public LngSubscription: Subscription;
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
  Years: number[];

  constructor(public Translate: TranslateService,private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private userinfo: userService, private lngService: LanguageService, ) {
    this.AddNewPolicyObj.VehicleDefionitionType = "2";
    this.newPolicyReq.VDT = "2";
    this.newPolicyReq.productType = "0000";
    this.newPolicyReq.IqamaNo = sessionStorage.getItem("IqamaNo");
    this.newPolicyReq.InsuredToken = sessionStorage.getItem("InsuredToken");
    this.newPolicyReq.IqamaNoforDis = sessionStorage.getItem("IqamaNo");
    this.isShowLoading = false;
    this.disableTOS = true;
    this.isError = false;
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });
  
    var d = new Date()
    this.Years= [];
    for (var i = 1980; i <= d.getFullYear()+1; i++) {
      this.Years.push(i)
    }
    
  }

  ngAfterViewInit() {
    $(document).ready(function () {
      $(".addNew").addClass("active")

    })
  }

  //declare let $: any;
  checked(Event: any) {
    if (Event.target.checked) {
      this.AddNewPolicyObj.Transfer = true;
    }
    else {
      this.AddNewPolicyObj.Transfer = false;
    }
  }

  Proceed() {
    this.router.navigate(['./NewDashboard/InsuredInfo']);
  }
  
  BUYPolicy() {
    sessionStorage.removeItem("mp");
    this.isShowLoading = true;
    this.isError = false;
    this.newPolicyReq.RegNo = sessionStorage.getItem("RegNo");

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.newPolicyReq));

    //this.http.post<AddNewPolicyReqMdl>(this.apiUrl.baseURL+"newPolicy/addNewPolicy",this.newPolicyReq,this.userinfo.getHttpOptions())
    this.http.post<mdlPayloadResponse>(this.apiUrl.baseURL + "newPolicy/addNewPolicy", this.objPayloadRequest, this.userinfo.getHttpOptions())
      .toPromise().then((result) => {
        this.isShowLoading = false;
        //this.newPolicyRes=result;

        //New Line Start
        this.objPayloadResponse = result;
        let objResObj: AddNewPolicyReqMdl = new AddNewPolicyReqMdl();
        objResObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        if (objResObj.RegNo != this.newPolicyReq.RegNo) {
          Swal("Invalid Response", "Technical Error: Request Object Does Not Match With Response Object", "error")
          this.router.navigate(['BeforeLogin/NewReg']);
          return;
        }
        this.newPolicyRes = objResObj;
        //NewLine End

        if (this.newPolicyRes.st.StatusCode === "S") {
          sessionStorage.setItem("newPolicyObj", this.EncriptService.EncriptObject(JSON.stringify(this.newPolicyRes)));
          sessionStorage.setItem("CurrentRoute", "InsuredInfo");
          this.router.navigate(['./NewDashboard/MotorProposalForm/InsuredInfo']);
          this.isError = false;
        } else {
          if (this.newPolicyRes.st.StatusCode == "F" && this.newPolicyRes.st.StatusDesc == "You can't proceed because not registered in Saudi post address") {
            if (this.Lng == "en") {
              let stHTML: string;
              stHTML = "<p style='font-size:16px;'>Dear customer Please register or update your own National Address: <a href='https://register.address.gov.sa/ar/individual/' target='_blank'>https://register.address.gov.sa/ar/individual/" + "</a></p>";
              Swal({
                title: '',
                html: stHTML,
                type: "info",
                width: '50%',
              });
            } else {
              let stHTML: string;
              stHTML = "<p style='font-size:16px;'>عزيزنا العميل نرجو تسجيل أو تحديث بياناتك في العنوان الوطني عن طريق الرابط التالي<a href='https://register.address.gov.sa/ar/individual/' target='_blank'>https://register.address.gov.sa/ar/individual/" + "</a></p>";
              Swal({
                title: '',
                html: stHTML,
                type: "info",
                width: '50%',
              });
            }
            this.isError = true;
          } else {
           // this.Lng == "ar" ?  Swal(this.newPolicyRes.st.StatusDescAr) : Swal(this.newPolicyRes.st.StatusDesc);
           Swal(this.Translate.instant(this.newPolicyRes.st.StatusDesc))
            this.isError = true;
          }

        }
      }, (error) => {
        this.isShowLoading = false;
        this.userinfo.checkTokenStatus(error);
      });
  }

  SetTransferOfOwnerShip(val) {
    if (val == "3") {
      this.newPolicyReq.isTransferOfShip = false;
      this.disableTOS = false;
      this.newPolicyReq.OwnerIqamaNo = "";
    }
    else {
      this.disableTOS = true;
    }
  }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/NewProposal/NewProposal.ts